<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00001">
<h2 class="nobreak" id="Inhalt">Inhalt.</h2>
</div>
<table class="toc" summary="">
<tbody class="calibre11"><tr class="calibre12">
<td class="s10">
       
    </td>
<td class="s10">
<div class="right">Seite</div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Erstes Kapitel.</em> Die Türkei im
      Weltkrieg</div>
</td>
<td class="vab">
<div class="right"><a href="#/Text/Section0004#Erstes_Kapitel">1</a></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Zweites Kapitel.</em> Aleppo</div>
</td>
<td class="vab">
<div class="right"><a href="#/Text/Section0005#Zweites_Kapitel">8</a></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Drittes Kapitel.</em> Eine mißglückte
      Autofahrt</div>
</td>
<td class="vab">
<div class="right"><a href="#/Text/Section0006#Drittes_Kapitel">18</a></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Viertes Kapitel.</em> Mein neuer
      Feldzugsplan</div>
</td>
<td class="vab">
<div class="right"><a href="#/Text/Section0007#Viertes_Kapitel">36</a></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Fünftes Kapitel.</em> Auf den Wellen
      des Euphrat</div>
</td>
<td class="vab">
<div class="right"><a href="#/Text/Section0008#Fuenftes_Kapitel">41</a></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Sechstes Kapitel.</em> Unter Nomaden
      und armenischen Flüchtlingen</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0009#Sechstes_Kapitel" title="Link target outside of Sample">52</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Siebentes Kapitel.</em> Deutsche
      Artillerie auf dem Wege nach Bagdad</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0010#Siebentes_Kapitel" title="Link target outside of Sample">73</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Achtes Kapitel.</em> Im Reich der
      Palmen</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0011#Achtes_Kapitel" title="Link target outside of Sample">83</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Neuntes Kapitel.</em> Mein Einzug in
      Bagdad</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0012#Neuntes_Kapitel" title="Link target outside of Sample">103</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Zehntes Kapitel.</em> Bagdad einst und
      jetzt</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0013#Zehntes_Kapitel" title="Link target outside of Sample">118</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Elftes Kapitel.</em> Sommertage in
      „Dar-es-Salaam“</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0014#Elftes_Kapitel" title="Link target outside of Sample">145</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Zwölftes Kapitel.</em> Zwei Deutsche:
      von der Goltz und Moltke</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0015#Zwoelftes_Kapitel" title="Link target outside of Sample">181</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Dreizehntes Kapitel.</em> Kut-el-Amara</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0016#Dreizehntes_Kapitel" title="Link target outside of Sample">191</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Vierzehntes Kapitel.</em> Meine Fahrt
      nach Babylon</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0017#Vierzehntes_Kapitel" title="Link target outside of Sample">211</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Fünfzehntes Kapitel.</em> Bibel und
      Babel</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0018#Fuenfzehntes_Kapitel" title="Link target outside of Sample">234</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Sechzehntes Kapitel.</em> Die Ruinen
      Babylons</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0019#Sechzehntes_Kapitel" title="Link target outside of Sample">247</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Siebzehntes Kapitel.</em> Eine deutsche
      Studierstube am Euphrat</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0020#Siebzehntes_Kapitel" title="Link target outside of Sample">276</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Achtzehntes Kapitel.</em> Samarra, die
      Hauptstadt des Kalifen Mutawakkil</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0021#Achtzehntes_Kapitel" title="Link target outside of Sample">284</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Neunzehntes Kapitel.</em> Die Karawane
      des Herzogs</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0022#Neunzehntes_Kapitel" title="Link target outside of Sample">300</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Zwanzigstes Kapitel.</em> Die
      Königsstadt Assur</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0023#Zwanzigstes_Kapitel" title="Link target outside of Sample">314</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Einundzwanzigstes Kapitel.</em>
      Erlebnisse auf einer Etappenstraße</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0024#Einundzwanzigstes_Kapitel" title="Link target outside of Sample">327</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Zweiundzwanzigstes Kapitel.</em>
      Mosul</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0025#Zweiundzwanzigstes_Kapitel" title="Link target outside of Sample">342</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Dreiundzwanzigstes Kapitel.</em>
      Ninive</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0026#Dreiundzwanzigstes_Kapitel" title="Link target outside of Sample">364</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Vierundzwanzigstes Kapitel.</em>
      Die Keilschrift und die älteste Bibliothek der Welt</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0027#Vierundzwanzigstes_Kapitel" title="Link target outside of Sample">375</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Fünfundzwanzigstes Kapitel.</em>
      Über Mardin zurück nach Aleppo</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0028#Fuenfundzwanzigstes_Kapitel" title="Link target outside of Sample">385</span></div>
</td>
</tr>
<tr class="calibre12">
<td class="vat">
<div class="left"><em class="gesperrt">Sechsundzwanzigstes Kapitel.</em>
      Assyrien und Babylonien</div>
</td>
<td class="vab">
<div class="right"><span href="#/Text/Section0029#Sechsundzwanzigstes_Kapitel" title="Link target outside of Sample">401</span></div>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?a1a51e06